import { tv, type VariantProps } from "tailwind-variants";

export const awardsCarouselContentVariant = tv({
  slots: {
    container: ["relative", "w-full", "flex flex-col gap-5 lg:flex-row"],
    imageWrapper: [
      "relative flex",
      "w-full h-full aspect-square lg:w-1/2 lg:max-h-screen",
      "bg-background-neutral-strong-static",
      "rounded-2xl border border-border-neutral-default",
      "overflow-hidden",
    ],
    image: ["w-full", "h-auto", "object-contain"],
    accordionWrapper: ["flex flex-col self-center", "w-full h-full p-5 lg:p-10 lg:w-1/2"],
    accordionItem: [
      "relative flex flex-col px-5 py-7.5 border-l-2 border-border-static-black/15 dark:border-border-static-black/25",
      "after:content-[''] after:absolute after:left-[-2px] after:top-0 after:w-0.5 after:origin-top",
      "after:h-0 after:bg-border-static-black/75",
      "data-[state=open]:gap-5 data-[state=open]:after:animate-[accordion-progress_8s_linear_forwards]",
      "data-[state=closed]:after:h-0",
    ],
    title: ["text-text-neutral-default text-left"],
    description: ["max-w-lg text-text-neutral-soft"],
    accordionContent: [
      "transition-opacity",
      "duration-300",
      "ease-out",
      "data-[state=closed]:opacity-0",
      "data-[state=open]:opacity-100",
    ],
  },
  variants: {},
  defaultVariants: {},
});

export const awardsCarouselVariant = tv({
  slots: {
    base: ["w-full py-10"],
    container: ["container-fluid"],
    header: ["flex flex-col gap-10", "w-full mb-10"],
    title: ["w-full max-w-3xl mx-auto", "text-center text-text-neutral-default"],
    description: ["w-full max-w-3xl mx-auto", "text-center text-text-neutral-soft"],
    content: [],
  },
  variants: {},
  defaultVariants: {},
});

export type AwardsCarouselVariantProps = VariantProps<typeof awardsCarouselVariant>;
export type AwardsCarouselReturnVariantProps = ReturnType<typeof awardsCarouselVariant>;
